import { render, staticRenderFns } from "./licenca-vencida.vue?vue&type=template&id=c6b8cc80&"
import script from "./licenca-vencida.vue?vue&type=script&lang=js&"
export * from "./licenca-vencida.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports